import { useEffect, useState } from "react";
import { postAccount } from "./accountApi";
import { refreshCurrentUser } from "./useCurrentUser";

// Only for the server's own headless Chrome, which prints a report to PDF for the
// report ready email (java util/ReportPdf.java): its link carries a one-time token
// (rt) that /renderlogin trades for a session-only login as the report's owner. The
// page waits for that before anything asks who is logged in, then drops the token
// from the address. Any other visit renders straight away.
export const renderToken = (search) => {
    const t = new URLSearchParams(search).get('rt');
    return t && /^[A-Za-z0-9_-]{16,200}$/.test(t) ? t : null;
};

const RenderLoginGate = ({children}) => {
    const [token] = useState(() => renderToken(window.location.search));
    const [ready, setReady] = useState(!token);
    useEffect(() => {
        if (!token) return;
        const params = new URLSearchParams(window.location.search);
        params.delete('rt');
        const q = params.toString();
        window.history.replaceState(window.history.state, '', window.location.pathname + (q ? '?' + q : ''));
        postAccount('/renderlogin', {token})
            .catch(() => null)
            .then((r) => {
                if (!r || !r.ok) document.documentElement.dataset.pdfReady = 'login failed';
                return refreshCurrentUser();
            })
            .finally(() => setReady(true));
    }, [token]);
    return ready ? children : null;
};

export default RenderLoginGate;
